import { useEffect } from "react";

import { AES } from "crypto-js";

import { appConfig } from "../../config/Config";
import { HttpMainApi } from "../../interface/main-api";
import { HttpUnAuthApi } from "../../interface/unauth-api";

const HaiSsoLogin = () => {
  const mainApi = new HttpMainApi();
  const unAuthApi = new HttpUnAuthApi();

  useEffect(() => {
    const ssoLogin = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code") || "";
      const state = urlParams.get("state") || "";
      const clientId = urlParams.get("client_id") || "";

      if (!code) {
        alert("HAI SSO code가 없습니다.");
        return;
      }

      try {
        const res = await unAuthApi.post({
          command: "hai_sso_login",
          code,
          state,
          client_id: clientId,
          redirect_uri: `${window.location.origin}/haiSsoLogin`,
        });

        if (`${res.code}` === "200" && res.response?.user_id) {
          await check_user(res.response.user_id);
          return;
        }

        alert(
          res.response?.error_msg || "HAI SSO 로그인에 실패했습니다."
        );
      } catch (error) {
        console.error("[HAI SSO] 로그인 요청 실패", error);
        alert("HAI SSO 로그인 중 오류가 발생했습니다.");
      }
    };

    ssoLogin();
    // HAI callback은 페이지 진입 시 한 번만 처리한다.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const check_user = async (key_id: string) => {
    const param: any = {
      command: "get_user_info",
      user_id: key_id,
    };
    const res = await mainApi.post(param);
    if (`${res.code}` === "200") {
      if (res.response.result === "success") {
        procSesson(res.response.user_info);
      }
    } else {
      console.log("error_msg: ", res);
      alert(res.response?.error_msg || "사용자 정보를 확인할 수 없습니다.");
    }
  };

  const procSesson = (sessionData: any) => {
    const sessionObj: any = {
      id: sessionData.sk,
      name: sessionData.name,
      company: sessionData.company,
      dept: sessionData.dept,
      isAuth: sessionData.is_auth,
      isAdmin: sessionData.is_admin,
      isSuperAdmin: sessionData.is_super_admin,
      dtype: sessionData.dtype,
      expire: Date.now() + 1000 * 60 * 60 * 24,
    };
    const objString = JSON.stringify(sessionObj);
    const encObjString = AES.encrypt(objString, appConfig.seed).toString();
    window.localStorage.setItem(appConfig.sessionName, encObjString);

    const rememberIdObj: any = {
      id: sessionData.id,
      remember: "TRUE",
    };
    const objRememberId = JSON.stringify(rememberIdObj);
    if (objRememberId) {
      window.localStorage.setItem(appConfig.rememberidSSName, objRememberId);
    }
    window.location.href = "/myAccount";
  };

  return (
    <div className="wrapper hart-login">
      <div className="hart-login-box">
        <p>HAAP </p>
        <div className="form-wrap">
          HAI SSO 로그인 처리 중입니다.
        </div>
        <div className="hart-footer">
          <p className="copyright">© Hyundai. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default HaiSsoLogin;
